import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, FacebookIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { company } from '../data/company';
import { services } from '../data/services';
import { cities } from '../data/cities';
export function Footer() {
  const {
    t,
    b
  } = useLanguage();
  const year = new Date().getFullYear();
  return <footer className="bg-navy-dark text-white/70" data-id="element-36" data-mp="3ugbqj7nstejc">
      <div className="mx-auto max-w-page px-4 py-16 sm:px-6 lg:px-8" data-id="element-37" data-mp="38qyt7e9m7ve">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-12" data-id="element-38" data-mp="36mu4n8jl4u2">
          <div className="lg:col-span-4" data-id="element-39" data-mp="3ldkcr17ga6oj">
            <div className="flex items-center gap-3" data-id="element-40" data-mp="3lgon6gbidynn">
              <img src={company.logo} alt="" className="h-14 w-14 rounded bg-white object-contain p-1" width={56} height={56} data-id="element-41" data-mp="3qc40961ozqj0" />
              <div data-id="element-42" data-mp="2ezl5i2sd69i5">
                <p className="font-display text-base font-bold leading-tight text-white" data-id="element-43" data-mp="2evxb71f3hj2d">{company.name}</p>
                <p className="text-sm font-semibold text-cta-light" data-id="element-44" data-mp="3gah0psdvrh5b">{b(company.tagline)}</p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed" data-id="element-45" data-mp="3v7zw3dl2cslq">{t('footer.about')}</p>
          </div>

          <nav className="lg:col-span-3" aria-labelledby="footer-services" data-id="element-46" data-mp="3q8dgwylod2aa">
            <h2 id="footer-services" className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-47" data-mp="82qthw25bzvb">
              {t('footer.services')}
            </h2>
            <ul className="mt-5 space-y-2.5 text-sm" data-id="element-48" data-mp="31umvaqetzm7">
              {services.slice(0, 6).map(service => <li key={service.slug} data-id="element-49" data-mp="ctqnotjvs3u4">
                  <Link to={`/services/${service.slug}`} className="transition-colors duration-150 ease-smooth hover:text-white" data-id="element-50" data-mp="cus1v6w716g2">
                    {b(service.title)}
                  </Link>
                </li>)}
              <li data-id="element-51" data-mp="tvw7qgxe1ffz">
                <Link to="/#services" className="font-semibold text-brand-300 hover:text-white" data-id="element-52" data-mp="twfnbqzkfrqu">
                  {t('footer.viewAllServices')}
                </Link>
              </li>
            </ul>
          </nav>

          <nav className="lg:col-span-2" aria-labelledby="footer-areas" data-id="element-53" data-mp="13rzkshts2yhp">
            <h2 id="footer-areas" className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-54" data-mp="18l2c0jb31vuq">
              {t('footer.areas')}
            </h2>
            <ul className="mt-5 space-y-2.5 text-sm" data-id="element-55" data-mp="1hkfgexkcnu8l">
              {cities.slice(0, 5).map(city => <li key={city.slug} data-id="element-56" data-mp="1mj8uos7gnp9t">
                  <Link to={`/service-areas/${city.slug}`} className="transition-colors duration-150 ease-smooth hover:text-white" data-id="element-57" data-mp="1mkbk0vp4xjnm">
                    {city.name}, WA
                  </Link>
                </li>)}
              <li data-id="element-58" data-mp="3tb18nwmogii1">
                <Link to="/#service-areas" className="font-semibold text-brand-300 hover:text-white" data-id="element-59" data-mp="3tai2fd6e3iju">
                  {t('footer.viewAllAreas')}
                </Link>
              </li>
            </ul>
          </nav>

          <div className="lg:col-span-3" data-id="element-60" data-mp="25mkess4fc6ea">
            <h2 className="font-display text-sm font-bold uppercase tracking-wider text-white" data-id="element-61" data-mp="21m0krxf5diwd">
              {t('footer.contact')}
            </h2>
            <ul className="mt-5 space-y-3 text-sm" data-id="element-62" data-mp="1wlmas9tzjyvp">
              <li className="flex items-start gap-2.5" data-id="element-63" data-mp="2tcy8so6kkfbi">
                <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-300" aria-hidden="true" data-id="element-64" data-mp="2tbn32itkcxhr" />
                <a href={company.phoneHref} className="font-semibold text-white hover:text-brand-300" data-id="element-65" data-mp="2pajmtv7lszg0">
                  {company.phone}
                </a>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-66" data-mp="2fdylpkypg8hg">
                <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-300" aria-hidden="true" data-id="element-67" data-mp="18yef8jmd046v" />
                <a href={company.emailHref} className="break-all hover:text-white" data-id="element-68" data-mp="13ys1m92mclxj">
                  {company.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-69" data-mp="2rtmxmgepkv75">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-300" aria-hidden="true" data-id="element-70" data-mp="2wnhkfspm1qag" />
                <span data-id="element-71" data-mp="2iw48azu17upg">{company.city}</span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-72" data-mp="2ntw8eh4tyn4q">
                <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-300" aria-hidden="true" data-id="element-73" data-mp="2nunvt4o9xejx" />
                <span data-id="element-74" data-mp="3bk8fxqw5yhus">{b(company.hours)}</span>
              </li>
            </ul>
            <Link to="/#contact" className="mt-5 inline-flex rounded-md bg-cta px-4 py-2.5 text-sm font-bold text-white transition-colors duration-200 ease-smooth hover:bg-cta-dark" data-id="element-75" data-mp="3fk0ow4pgyq0o">
              {t('cta.inspection')}
            </Link>
            <div className="mt-6" data-id="element-76" data-mp="1q649niq4jdv1">
              <h3 className="text-xs font-bold uppercase tracking-wider text-white" data-id="element-77" data-mp="1q4swisasgtr9">{t('footer.legal')}</h3>
              <div className="mt-3 flex items-center gap-3" data-id="element-78" data-mp="1v6rzi12m9ono">
                <a href={company.facebook} target="_blank" rel="noreferrer noopener" aria-label="Facebook" className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-white/20 transition-colors duration-150 ease-smooth hover:border-brand-300 hover:text-white" data-id="element-79" data-mp="1nl66zrcm99jz">
                  <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="13x6yyo9fsgi9" />
                </a>
                <Link to="/#contact" className="text-sm hover:text-white" data-id="element-81" data-mp="zwwqn4y69e08">
                  {t('footer.privacy')}
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs sm:flex-row sm:items-center sm:justify-between" data-id="element-82" data-mp="18wtb0udj3qph">
          <p data-id="element-83" data-mp="l5w641k5htnq">
            © {year} {company.name}. {t('footer.rights')}
          </p>
          <p data-id="element-84" data-mp="g7meg0xmxb6v">{company.license}</p>
          <div className="flex gap-4" data-id="element-85" data-mp="g6jnjt0bb8qy">
            <Link to="/#services" className="hover:text-white" data-id="element-86" data-mp="2gbf69jlvjwtp">
              {t('footer.sitemap')}
            </Link>
            <Link to="/#contact" className="hover:text-white" data-id="element-87" data-mp="2l8fb5r6zmtj8">
              {t('footer.terms')}
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}